module.exports = __webpack_public_path__ + "static/media/litentry.131dac06.png";